import {
  STORE_SETTINGS_PUBLIC_REQUEST,
  STORE_SETTINGS_PUBLIC_SUCCESS,
  STORE_SETTINGS_PUBLIC_FAIL,
} from "../Constants/StoreSettingConstants";

export const publicStoreSettingsReducer = (
  state = { loading: false, settings: {} },
  action
) => {
  switch (action.type) {
    case STORE_SETTINGS_PUBLIC_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case STORE_SETTINGS_PUBLIC_SUCCESS:
      return {
        loading: false,
        error: null,
        settings: action.payload,
      };

    case STORE_SETTINGS_PUBLIC_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};